import "./App.css";
import Router from "./routes/Router";
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "./assests/css/style.css";
import "./assests/css/bootstrap.min.css";
// import "./assests/css/bootstrap.css";
import "./assests/css/ddmenu.css";

import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";
import "swiper/css/bundle";

// import "./assests/css/responsive.css";
function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
